import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 12,
	viewBox: "0 0 10 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M4.8125 6.375C6.31641 6.375 7.5625 5.15039 7.5625 3.625C7.5625 2.12109 6.31641 0.875 4.8125 0.875C3.28711 0.875 2.0625 2.12109 2.0625 3.625C2.0625 5.15039 3.28711 6.375 4.8125 6.375ZM5.88672 7.40625H3.7168C1.6543 7.40625 0 9.08203 0 11.1445C0 11.5527 0.322266 11.875 0.730469 11.875H8.87305C9.28125 11.875 9.625 11.5527 9.625 11.1445C9.625 9.08203 7.94922 7.40625 5.88672 7.40625Z",
		fill: "#7B61FF"
	})]
});
const ForwardRef = forwardRef(SvgUserFilled);
export { ForwardRef as ReactComponent };
